// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".styles_link__7ECv0{color:var(--color-turquoise);font-family:var(--font-main)}.styles_link__7ECv0.styles_disabled__rGP\\+d{color:var(--color-iq-silver);cursor:not-allowed}", "",{"version":3,"sources":["webpack://./src/components/Link/styles.module.scss"],"names":[],"mappings":"AAAA,oBACE,4BAAA,CACA,4BAAA,CAEA,4CACE,4BAAA,CACA,kBAAA","sourcesContent":[".link {\n  color: var(--color-turquoise);\n  font-family: var(--font-main);\n\n  &.disabled {\n    color: var(--color-iq-silver);\n    cursor: not-allowed;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"link": "styles_link__7ECv0",
	"disabled": "styles_disabled__rGP+d"
};
export default ___CSS_LOADER_EXPORT___;
